import * as yup from 'yup';
import IMPSBaseModel from './imps-base-model';

export enum RxStatus {
    Taking = 1,
    NotTaking = 2,
    Unknown = 3
}

export enum PatientRxSource {
    EncounterRx,
    PatientRx
}

export const RxStatusTexts = {
    [RxStatus.Taking]: 'TAKING',
    [RxStatus.NotTaking]: 'NOT TAKING',
    [RxStatus.Unknown]: 'UNKNOWN'
};

export class PatientRxModel {
    id: number = 0;

    source: PatientRxSource;

    medId: number = 0;

    dosageNumberTypeID?: number = 2;
    dosageFrequencyTypeID?: number = 2;

    status?: RxStatus = RxStatus.Taking;

    sigForm?: string;
}

export class PatientRx extends IMPSBaseModel {
    medId: number = 0;
    dispense: number = 0;
    refills: number = 0;
    daysSupply: Undefinable<number> = 7;
    durationType: Undefinable<number>;

    dosageNumberTypeID: Undefinable<number> = 2;
    dosageFrequencyTypeID: Undefinable<number> = 2;

    status: Undefinable<RxStatus> = RxStatus.Taking;

    sigForm: Undefinable<string>;
    dispenseForm: Undefinable<string>;

    createdDate: string;

    startDate: Undefinable<string>;
    reasonType: Undefinable<number>;
    reasonText: Undefinable<string>;
}

export const patientRxValidationSchema = yup.object().shape({
    medId: yup
        .number()
        .moreThan(0, 'Drug name is required.')
        .required('Drug name is required.'),
    dosageNumberTypeID: yup
        .number()
        .moreThan(0, 'Required.')
        .required('Required.'),
    dosageFrequencyTypeID: yup
        .number()
        .moreThan(0, 'Frequency is required.')
        .required('Frequency is required.'),
    dispense: yup
        .number()
        .moreThan(0, 'Dispense is required.')
        .required('Dispense is required.'),
});
